<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md7>
        <v-card class="rounded-card elevation-6 pa-3">
          <v-toolbar dark color="primary lighten-2">
            <v-toolbar-title>Sign Up</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat color="white" small outline @click="login"
              >Login?</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <!--            <span class="caption">Create a new Groupmail Account</span>-->
            <v-alert
              v-if="error"
              :value="true"
              type="error"
              icon="warning"
              class="mb-4"
              v-html="errorMessage"
            >
              {{ errorMessage }}
            </v-alert>
            <v-form
              id="signupForm"
              ref="form"
              v-model="valid"
              lazy-validation
              class="my-2"
              @submit.prevent
            >
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    v-model="firstname"
                    prepend-icon="person"
                    name="firstname"
                    label="First name"
                    type="text"
                    :rules="[v => !!v || 'First name is required']"
                    required
                    class="mb-0"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="lastname"
                    prepend-icon="blank"
                    name="lastname"
                    label="Last name"
                    type="text"
                    :rules="[v => !!v || 'Last name is required']"
                    required
                    class="mb-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-text-field
                v-model="teamname"
                prepend-icon="group"
                name="teamname"
                label="Team name"
                type="text"
                :rules="[v => !!v || 'Team name is required']"
                required
                counter
                maxlength="64"
                hint="Your team, business, club or organisation name. Used for account
                    management."
                class="mb-1"
              >
                <!--                <v-tooltip slot="append" bottom>-->
                <!--                  <v-icon slot="activator">info_outline</v-icon>-->
                <!--                  <span-->
                <!--                    >Your team, business, club or organisation name. Used for account-->
                <!--                    management.</span-->
                <!--                  >-->
                <!--                </v-tooltip>-->
              </v-text-field>
              <v-text-field
                v-model="website"
                prepend-icon="link"
                name="website"
                label="Website"
                type="url"
                :rules="websiteRules"
                validate-on-blur
                class="my-1"
              ></v-text-field>
              <v-text-field
                v-model="email"
                prepend-icon="email"
                name="email"
                label="Email Address"
                type="text"
                :rules="emailRules"
                validate-on-blur
                required
                class="my-1"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                prepend-icon="lock"
                name="password"
                browser-autocomplete="off"
                label="Password"
                :type="showPassword ? 'text' : 'password'"
                :rules="passwordRules"
                required
                class="my-1"
                hint="At least 7 characters"
                counter
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="!valid"
              type="submit"
              color="accent"
              round
              block
              :loading="loading"
              form="signupForm"
              @click="validate"
              >Sign up</v-btn
            >
          </v-card-actions>
          <v-dialog v-model="tandc" width="70%">
            <v-card>
              <v-card-title class="title">Terms & Conditions</v-card-title>
              <v-card-text>
                <span v-html="terms"></span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="tandc = false">Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="mpolicy" width="70%">
            <v-card>
              <v-card-title class="title">Messaging Policy</v-card-title>
              <v-card-text>
                <span v-html="messagingPolicy"></span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="mpolicy = false">Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="spolicy" width="70%">
            <v-card>
              <v-card-title class="title">Anti-Spam Policy</v-card-title>
              <v-card-text>
                <span v-html="spamPolicy"></span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="spolicy = false">Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <p class="caption grey--text lighten-2 mt-1 text-xs-center">
            By creating an account, you agree to our
            <a href="javascript:;" @click.stop="tandc = true"
              >terms and conditions</a
            >,
            <a href="javascript:;" @click.stop="mpolicy = true">messaging</a>
            and
            <a href="javascript:;" @click.stop="spolicy = true"
              >anti-spam policies</a
            >
          </p>
        </v-card>
        <v-btn
          flat
          color="secondary"
          small
          text
          class="text-lowercase font-weight-thin"
          @click="login"
          >Already have an account?</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    mpolicy: false,
    spolicy: false,
    tandc: false,
    showPassword: false,
    error: false,
    errorMessage: 'Error.',
    loading: false,
    valid: true,
    email: null,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid'
    ],
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 7) || 'Minimum 7 characters'
    ],
    websiteRules: [
      v => {
        if (v && v.length) {
          // eslint-disable-next-line
          const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm
          return pattern.test(v) || 'Please enter a valid website address';
        }
        return true;
      }
    ],
    password: '',
    firstname: null,
    lastname: null,
    teamname: null,
    website: null,
    spamPolicy: `It is a violation of the license agreement to send unsolicited commercial bulk email with any Groupmail Product.<br/><br/>
Notice of Responsibility to all Groupmail product users:<br/><br/>
DO NOT SEND UNSOLICITED COMMERCIAL BULK EMAIL OR UNSOLICITED COMMERCIAL BULK SMS MESSAGES. Be aware that you are solely responsible for the messages you send. In some cases, sending unsolicited commercial bulk email or unsolicited commercial bulk SMS (i.e. Spam) is in violation of the law, and you will be solely responsible, accountable and liable for any violations and damages.<br/><br/>
We reserve the right to refuse technical support and/or other services if you:<br/>
- send unsolicited commercial bulk email or send unsolicited commercial bulk SMS; or<br/>
- you hijack a mail server relay; or<br/>
- distribute illegal information or materials; or<br/>
- forge header information; or<br/>
- put false of misleading information in the subject; or<br/>
- fail to provide a means for unsubscribing from your lists<br/>
<br/>
The Groupmail range of products was developed to help people including us, to run and manage opt-in mailing lists, opt-in email newsletters, opt-in email marketing campaigns, announcement lists, customer updates and other legal uses of email and SMS messaging. We will never knowingly tolerate the use of our products to facilitate the sending of unsolicited commercial bulk email (i.e. spam) messages. We have taken measures to stop people from abusing our products – for example, our Groupmail Trial has limitations in it to stop it from being abused. Some of those limitations are:<br/><br/>
- BCC / Bulk sending is not permitted – spammers like to be able to send their email quickly – using bcc. This is not possible with the Groupmail.<br/>
- There is a limitation on the number of messages that can be sent at any one time in our GroupMail Trial. Again this is designed to deter spammers from using our Groupmail software to send spam.<br/>
- Direct sending is not available in Groupmail.<br/>
- None of our products allow message headers to be altered in anyway.<br/>
- None of our products facilitate the building of spam lists using extraction or spidering techniques.<br/>
<br/>
Users should consult Section 6 of the license agreement (installed by each of our products) for more information. If a user violates the license agreement, but continues to use the product they are doing so illegally. We will deny technical support and refunds, refuse product upgrades, report your actions to anti-spam agencies, and may pursue legal action.<br/><br/>
If you do receive spam that you believe originated from a Groupmail Product user, please forward the message with full headers (very important) to support@groupmail.io, so that we can investigate the matter further. Should the spam complaint be valid we will report them to the various anti-spam agencies, black list them from receiving future products and technical support from us. If you have any queries relating to our anti-spam/abuse policies then please contact us – support@groupmail.io.<br/><br/>
Please note that Groupmail does not provide mailing lists with its products. Nor does Groupmail provide mail servers to facilitate the sending of unsolicited bulk commercial email. The Groupmail product range is designed to allow users to operate and manage their own lists and groups.<br/><br/>
If you have any questions regarding our Anti Spam Policy please contact us – support@groupmail.io.`,
    messagingPolicy: `This Groupmail Messaging Policy (the “Messaging Policy”) applies to the Groupmail service, which includes the sending of digital messages and related digital messaging services (the “Services”) offered by Groupmail ltd, a Irish corporation, (“Groupmail,” “we,” ‘”us” or “our”) to any individual, organization, business entity, and/or user (“you” or “your”), through the website groupmail.io or any other websites or mobile applications (collectively, the “Site”) that reference or link to this Messaging Policy. Any capitalized terms used but not defined in this Messaging Policy will have the meaning given to such terms in the Terms of Use, the Privacy Policy, or your Order.<br/><br/>
YOU AGREE TO CREATE, STORE, AND SEND ALL DIGITAL MESSAGES USING THE SITE OR THE SERVICES IN STRICT COMPLIANCE WITH THIS MESSAGING POLICY. YOUR CONTINUED USE OF OR ACCESS TO THE SERVICES CONSTITUTES ACCEPTANCE OF THIS MESSAGING POLICY. IF YOU ARE NONCOMPLIANT WITH THIS MESSAGING POLICY, GROUPMAIL HAS THE SOLE DISCRETION TO TAKE ANY ACTION IT DEEMS APPROPRIATE REGARDING YOUR ACCESS TO THE SITE OR THE SERVICES, INCLUDING WITHOUT LIMITATION, IMMEDIATE SUSPENSION OR TERMINATION OF YOUR ACCESS TO THE SITE OR THE SERVICES WITHOUT NOTICE.<br/><br/>
Furnishing false or incorrect data on orders, contracts, applications or other materials to Groupmail, including fraudulent use of credit card numbers or telephone numbers.<br/><br/>
<strong>1. Compliance with Digital Message Sending Best Practices.</strong>
<br/><br/>
We require you to follow these best practices when sending Digital Messages using the Services:
<br/><br/>
1.1. Use only permission-based marketing Digital Message lists (i.e., lists in which each recipient has explicitly granted permission to receive Digital Messages from you by affirmatively opting-in to receive those Digital Messages).
<br/>
1.2. Always include a working “unsubscribe” mechanism in each marketing Digital Message that allows the recipient to opt out from your mailing list (receipt/transactional messages that are exempt from “unsubscribe” requirements of applicable law are exempt from this requirement).
<br/>
1.3. Comply with all requests from recipients to be removed from your mailing list within 10 days of receipt of the request or the appropriate deadline under applicable law.
<br/>
1.4. Maintain, publish, and comply with a privacy policy that meets all applicable legal requirements, whether or not your organization controls the sending of the Digital Messages.
<br/>
1.5. Include in each Digital Message a link to your then-current privacy policy applicable to that Digital Message.
<br/>
1.6. Include in each Digital Message your valid physical mailing address or a link to that information.
<br/>
1.7. Do not send to addresses obtained from purchased or rented Digital Message lists.
<br/>
1.8. Do not use third party message addresses, domain names, or mail servers without proper permission.
<br/>
1.9. Do not routinely send Digital Messages to non-specific addresses (e.g., webmaster@domain.com or info@domain.com).
<br/>
1.10. Do not send Digital Messages that result in an unacceptable number of spam or similar complaints (even if the Digital Messages themselves are not actually spam).
<br/>
1.11. Do not disguise the origin, or subject matter of, any Digital Message or falsify or manipulate the originating message address, subject line, header, or transmission path information for any Digital Message.
<br/>
1.12. Do not send offers for the purpose of obtaining personal information or generating leads for third parties.
<br/>
1.13. Do not send “chain letters,” “pyramid schemes,” or other types of messages that encourage the recipient to forward the content to strangers.
<br/>
1.14. Do not send to lists of addresses that are programmatically generated or scraped from the Web.
<br/>
1.15. Do not employ sending practices, or have overall message delivery rates, which negative impact the Services or other users of the Services.
<br/>
1.16. Do not use the Services to send messages that may be considered junk mail. Some examples of this type of messages include messaging related to: affiliate marketing, penny stocks, gambling, multi-level marketing, direct to consumer pharmaceutical sales, payday loans, etc.
<br/><br/>
<strong>2. Compliance with law.</strong>
<br/><br/>
Your use of the Services must comply with all applicable laws, rules, regulations, and court orders of any kind of any jurisdiction applicable to you, us, and any recipient to whom you use the Services to send Digital Messages (“Applicable Law”). You have the responsibility to be aware of and understand all Applicable Laws and ensure that you and all Users of your Account comply at all times with Applicable Law. Some examples of Applicable Laws include: the U.S. CAN-SPAM ACT, The E.U. Directive of Privacy and Electronic Communications, the U.K. Privacy and Electronic Communications (EC Directive) Regulations 2003; the Canada Anti-Spam Law (CASL) and/or any similar law, laws relating to intellectual property, privacy, security, terrorism, corruption, child protection, or import/export laws.
<br/><br/>
<strong>3. Commitment Against Harassment and Interference with Others.</strong>
<br/><br/>
You must not use the Services to:
<br/><br/>
3.1. Store, distribute or transmit any malware or other material that you know, or have reasonable grounds to believe, is or may be tortious, libelous, offensive, infringing, harassing, harmful, disruptive or abusive; or
<br/>
3.2. Commit (or promote, aid or abet) any behavior, which you know, or have reasonable grounds to believe, is or may be tortious, libelous, offensive, infringing, harassing, harmful, disruptive or abusive. Examples may include Digital Messages that are themselves are or promote racism, homophobia, or other hate speech.
<br/><br/>
<strong>4. Sensitive Information.</strong>
<br/><br/>
You will not import, or incorporate into, any contact lists or other content you upload to the Services or the Site, any of the following information: social security numbers, national insurance numbers, credit card data, passwords, security credentials, bank account numbers, or sensitive personal, health or financial information of any kind.
<br/><br/>
<strong>5. Modifications to this Policy.</strong>
<br/><br/>
We may modify this Messaging Policy prospectively at any time by posting the revised version on the Site and/or sending you a copy of the modified document through other reasonable means. Your continued use of the Services will be considered acceptance of any such modification. All modifications to this Policy will be effective immediately upon posting, unless otherwise noted by us.`,
    terms: `By viewing this site the user is deemed to consent to all terms and conditions below. By downloading software from this site the user is deemed to consent to this and the license agreements included with the downloaded software (s).<br><br>
The content of this site is protected by copyright pursuant to Irish and European Union copyright laws, international conventions and other copyright laws. The user is specifically prohibited from modifying, publishing, transmitting, selling, participating in the transfer or sale or reproducing, creating derivative works from, distributing, performing, displaying or in any way exploiting any of the materials on this site or the softwares or materials relating thereto in whole or in part without express written permission.<br><br>
All trademarks on this site such as GroupMail, Infacta and others are trademarks of the respective companies and you may not use these marks without express written permission.<br><br>
Groupmail Ltd. excludes any warranty, expressed or implied as to the quality, accuracy, timeliness, completeness or fitness for a particular purpose of the material on Groupmail.io or Group-Mail.com and will not be liable for any claims, penalties, loss, damages or expenses arising from the use or the inability to use Groupmail materials (site, content, software products or services), or from any unauthorized access or alteration of Groupmail.io or Group-Mail.com.<br><br>
Groupmail Ltd. makes no warranty that the contents of the Groupmail.io and Group-Mail.com and Infacta.com websites are compatible with all computer systems and browsers.<br><br>
The user accepts that after leaving the Groupmail.io or Group-Mail.com or Infacta.com website(s) Groupmail Ltd. cannot be responsible in any way for any material that you encounter and we exclude to the fullest extent permitted by law all liability that may arise with respect to or as a result of such material causing any damage, costs, injury or financial loss of any kind.<br><br>
Groupmail Ltd. reserves the right to add to or change the terms of this agreement. It is your responsibility to refer to and comply with these terms on accessing Groupmail.io and Group-Mail.com<br><br>
Groupmail Ltd. reserves the right to change all aspects of all Groupmail owned properties (site content, software, prices etc.) at any time.<br><br>
These terms and conditions of use shall be construed and interpreted in accordance with Irish Law. The Courts of Ireland shall have exclusive jurisdiction in relation to any claim, dispute or other matter arising there from.<br><br>
A User may not use any Groupmail Product or Service to send email or SMS messages or to transmit any electronic communications using a name, email address, SenderID or phone number of someone other than the User for purposes of deception or fraud. Any attempt to impersonate someone else by altering an email address or header, SMS SenderID or phone number, source IP address information or any other identifying information is prohibited. Any attempt to fraudulently conceal, forge or otherwise falsify a User’s identity in conjunction with the use of any Groupmail Product or Service is prohibited.<br><br>
Forging or misrepresenting email or SMS message headers or identities, whether in whole or in part, to mask the originator of the message, is prohibited.<br><br>
Users agree to use Groupmail’s email and SMS messaging Products and Services only for lawful purposes. Use of any Groupmail Product or Service for transmission, distribution, retrieval or storage of any information, data or other material in violation of any applicable law or regulation (including, where applicable, any tariff or treaty) is prohibited. This includes, without limitation, the use or transmission of any data or material protected by copyright, trademark, trade secret, patent or other intellectual property right without proper authorization and the transmission of any material that constitutes an illegal threat, violates control laws or is obscene, defamatory or otherwise unlawful.<br><br>
Using any Groupmail Product or Service to send or distribute Internet Viruses, Worms, Trojan Horses or any other malicious or destructive elements is prohibited. Activities that disrupt the use of or interfere with the ability of others to effectively use Groupmail Products or Services or any connected network, system, service or equipment are likewise prohibited.<br><br>
The following activities are also prohibited:<br><br>
Intentionally using any Groupmail Product or Service to send or transmit files containing corrupted data.<br><br>
Using any Groupmail Product or Service for Harassment, whether through language, frequency or size of messages.<br><br>
Furnishing false or incorrect data on orders, contracts, applications or other materials to Groupmail, including fraudulent use of credit card numbers or telephone numbers.<br><br>
Using any Groupmail Product or Service to engage in activities that are determined to be illegal, such as the distribution of pyramid or ponzi schemes, is prohibited.<br><br>
Using any Groupmail Product or Service or any associated or connected networks to advertise, transmit, store, send, distribute or otherwise make available child pornography or other illegal obscene speech or material is prohibited.<br><br>
Using any Groupmail Product or Service as a means to send, distribute or transmit defamatory, harassing, abusive, threatening or hateful language is prohibited.<br><br>
Using any Groupmail Product or Service to promote scams, frauds or to engage in any misrepresentation.
`
  }),
  mounted: function() {
    if (this.$route.query.email) {
      const email = decodeURIComponent(this.$route.query.email);
      if (email && typeof email !== 'undefined') this.email = email;
    }
  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        this.error = false;
        this.errorMessage = '';
        this.loading = true;
        try {
          const response = await this.signup({
            email: this.email,
            password: this.password,
            teamname: this.teamname,
            firstname: this.firstname,
            lastname: this.lastname,
            website: this.website
            // timezone: moment.tz.guess()
          });
          // console.log('signup response:', response);
          if (response && response.success) {
            this.setSnack('Account creation successful. Logging in now...');
            this.$ga.event({
              eventCategory: 'account',
              eventAction: 'signup',
              eventLabel: this.email
            });
            const response2 = await this.autologin({
              email: this.email,
              password: this.password,
              teamId: response.team._id
            });
            // console.log('autologin response:', response2);
            this.loading = false;
            if (response2 && response2.success) {
              this.setSnack('Login successful');
              this.$router.push('/downloads'); // was dashboard
            } else {
              this.setSnack(
                `Automatic login failed: ${
                  response2 ? response2.message : 'unknown error :('
                }`
              );
              this.$router.push('/login');
            }
          } else {
            this.loading = false;
            this.errorMessage = response
              ? response.message
              : 'Signup process failed with unknown error. Please try again.';
            this.error = true;
          }
        } catch (error) {
          this.loading = false;
          this.errorMessage = error.message;
          this.error = true;
        }
      }
    },
    login() {
      if (this.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.$router.push(`/login?email=${this.email}`);
      } else {
        this.$router.push('/login');
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      autologin: 'auth/login',
      signup: 'account/signup'
    })
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
